import React from 'react';
import styled from 'styled-components';

export const customStyles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    width: '90%',
    maxWidth: '500px',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'white',
    boxSizing: 'border-box',
    border: 'none',
    overflow: 'hidden',
  },
};

const centeredStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  top: '50%',
  left: '50%',
  width: '90%',
  maxWidth: '500px',
  padding: '20px',
  borderRadius: '10px',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  backgroundColor: 'white',
  boxSizing: 'border-box',
  border: 'none',
  overflow: 'hidden',
};

  
export const Title = styled.h2`
    text-align: center;
    color: #333;
    margin-bottom: 20px;
  `;

export const Paragraph = styled.p`
    color: #555;
    line-height: 1.6;
    margin: 1rem 0;
  `;
  
export const List = styled.ul`
    margin-bottom: 20px;
  `;
  
export const ListItem = styled.li`
    margin-bottom: 10px;
  `;
  
export const Button = styled.button`
    display: block;
    width: 100%;
    padding: 10px;
    margin-top: 20px;
    background-color: #EA7E76;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    text-align: center;
  `;
  
export const BackButton = styled.button`
    display: block;
    width: 100%;
    padding: 10px;
    margin-top: 10px;
    background-color: transparent;
    color: #EA7E76;
    border: 2px solid #EA7E76;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    text-align: center;
  `;